import { call, put, takeLatest } from "redux-saga/effects";

import {
  delete_ProductionIdSuccess,
  edit_ProductionIdSuccess,
  getProductionistPageSuccess,
  getProduction_Mode2_Success,
  getUnitIDForProdunctionSuccess,
  Save_ProductionSuccess,
  update_ProductionIdSuccess,
  ProductionApiErrorAction,
  ProductionIdReissueSuccess,
} from "./actions";
import {
  Production_Delete_API,
  production_Edit_API,
  production_get_API,
  production_Make_API,
  Production_Post_API,
  production_UnitDropdown_API,
  productionAndMaterialReissue_API,
} from "../../../helpers/backend_helper";

import {
  DELETE_PRODUCTION_ID,
  GET_PRODUCTION_ITEM_MODE_2,
  GET_PRODUCTION_LIST_PAGE,
  POST_PRODUCTION_FROM_PRODUCTION_PAGE,
  GET_UNIT_ID_FOR_PRODUNCTION,
  UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE,
  EDIT_PRODUCTION_FOR_PRODUCTION_PAGE,
  MATERIAL_REISSUE_PRODUCTION_ID,
} from "./actionType";

import { date_dmy_func, convertTimefunc, listpageConcatDateAndTime } from "../../../components/Common/CommonFunction";

function* SaveProductionGenFunc({ config }) {
  try {
    const response = yield call(Production_Post_API, config);
    yield put(Save_ProductionSuccess(response));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

function* DeleteProductionGenFunc({ config }) {
  try {
    const response = yield call(Production_Delete_API, config);
    yield put(delete_ProductionIdSuccess(response));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

function* UpdateProductionGenFunc({ config }) {
  try {
    const response = yield call(config);
    yield put(update_ProductionIdSuccess(response));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

// List Page API
function* get_PRODUCTION_GerFunc({ filters }) {

  try {
    const response = yield call(production_get_API, filters);
    const newList = response.Data.map((index) => {
      // index.Item = index.Item;
      var batchdate = date_dmy_func(index.BatchDate)

      const DateAndTimeLable = listpageConcatDateAndTime(index.ProductionDate, index.CreatedOn);
      index["transactionDate"] = `${index.CreatedOn}${DateAndTimeLable}`; // transactionDate for sorting and filtering data 
      index["transactionDateLabel"] = DateAndTimeLable;



      index.BatchDate = (`${batchdate} `)
      return index;
    });
    yield put(getProductionistPageSuccess(newList));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

// List Page API
function* getProduction_Mode2_GenFunc({ data }) {
  const { jsonBody, pageMode, path } = data;
  try {
    const response = yield call(production_Make_API, jsonBody);
    response.Data = response.Data[0];
    response["pageMode"] = pageMode;
    response["path"] = path; //Pagepath
    yield put(getProduction_Mode2_Success(response));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

// Edit Production  Page API
function* editProduction_GenFunc({ config }) {
  const { btnmode } = config;
  try {
    const response = yield call(production_Edit_API, config);
    response.pageMode = btnmode;
    yield put(edit_ProductionIdSuccess(response));
  } catch (error) { yield put(ProductionApiErrorAction()) }
};

//  DesignationID dropdown list
function* UnitIDForProduction_saga({ data }) {
  try {
    const response = yield call(production_UnitDropdown_API, data);
    const UnitDropdown = response.Data.map((index) => ({
      value: index.id,
      label: index.UnitName,
      IsBase: index.IsBase
    }));
    yield put(getUnitIDForProdunctionSuccess(UnitDropdown));
  } catch (error) { yield put(ProductionApiErrorAction()) }
}

function* ProductionReissue_GenFunc({ config }) {
  try {
    const response = yield call(productionAndMaterialReissue_API, config);

    // Dispatch success
    yield put(ProductionIdReissueSuccess(response));
  } catch (error) {
    yield put(ProductionApiErrorAction(error));
  }
}



function* ProductionSaga() {
  yield takeLatest(GET_PRODUCTION_ITEM_MODE_2, getProduction_Mode2_GenFunc);
  yield takeLatest(EDIT_PRODUCTION_FOR_PRODUCTION_PAGE, editProduction_GenFunc);
  yield takeLatest(POST_PRODUCTION_FROM_PRODUCTION_PAGE, SaveProductionGenFunc);
  yield takeLatest(UPDATE_PRODUCTION_ID_FROM_PRODUCTION_PAGE, UpdateProductionGenFunc);
  yield takeLatest(DELETE_PRODUCTION_ID, DeleteProductionGenFunc);
  yield takeLatest(GET_PRODUCTION_LIST_PAGE, get_PRODUCTION_GerFunc);
  yield takeLatest(GET_UNIT_ID_FOR_PRODUNCTION, UnitIDForProduction_saga);
 yield takeLatest(MATERIAL_REISSUE_PRODUCTION_ID, ProductionReissue_GenFunc);
}
export default ProductionSaga;
